import { VersionedAgentSchema } from "@redotech/redo-model/agents/versioned-agent";

export const getAgentById = {
  name: "getAgentById" as const,
  input: VersionedAgentSchema.pick({ _id: true }),
  output: VersionedAgentSchema,
};
